import { useI18n } from "common/useI18n";

export function useAdminTranslation() {
  return useI18n("admin");
}
